import type { FaireProductEntity } from "../../entity_types/product";

export const p_9dsn5nmbvu: FaireProductEntity = {
  token: "p_9dsn5nmbvu",
  type: "product",
  name: "Gingersnap Candle - FALL / HOLIDAY",
  brandToken: "b_7ltlwh1w",
  brandName: "True Hue",
  imageUrl:
    "https://cdn.faire.com/fastly/fdd15e9a56f2682624fa112d4cccf819e1ea0a919bd51d64136d1ab269403383.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6b9fc828bf6bd1d6aad29f6d28b1a564f061f43bb4fbe41861d52a54b522c1f0.jpeg",
    "https://cdn.faire.com/fastly/579aa766b0441b63ac233a6b41898fc8245546f3b059a9be382b872f103866c6.png",
    "https://cdn.faire.com/fastly/9dfb928f2f7b621208925c5aa86c4c2f32e570afe221a7e9bda1da643a223d44.jpeg",
  ],
  priceDollars: 14.5,
  description:
    '• Excellent Christmas gift!\n\nNotes: Ginger + Praline\n\nSomething sweet is stirring. Crystallized ginger and golden praline fold into brown sugar, molasses, and a splash of amaretto, softened by vanilla and cream. Cinnamon flickers through warm amber, leaving behind a scent that feels rich, spiced, and impossible to resist.\n\nThis 7.75 oz candle is comprised of a premium soy wax blend and fine fragrance oils (all are Prop 65 and I.F.R.A. approved). Each candle comes complete with a braided cotton wick which burns cleanly for 40–50 hours.\n\nMeasurements:\n\n• Box Size: 2.9" L X 2.9" W X 3.3" H\n\n• Candle Size: 2.9" D X 3.25" H',
  tags: [],
  msrpDollars: 29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:05.496Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
